<template>
	<feature-item :image="award.avatar" :thumbnail="award.avatar_thumbnail" :divided="divided" :title="award.amount ? toEuro(award.amount) : award.material"
				  :description="award.description">

		<check-list v-if="award.participationClasses && award.participationClasses.length" small class="mt-10">
			<check-list-item v-for="participationClass in award.participationClasses" :key="participationClass.id" :text="participationClass.name"
							 :help="$t('text.award.valid_for_class', {participation_class: participationClass.name})" class="px-0"/>
		</check-list>

		<template #info>
			<div>
				<chip v-if="!award.start_rank && !award.end_rank" color="success" small>{{ $t('label.all_ranks') }}</chip>
				<chip v-else-if="!award.end_rank" color="success" small>{{ award.start_rank }}. - &infin; {{ $t('label.rank') }}</chip>
				<chip v-else-if="!award.start_rank" color="success" small>1. - {{ award.end_rank }}. {{ $t('label.rank') }}</chip>
				<chip v-else color="success" small>{{ award.start_rank }}. <span v-if="award.start_rank !== award.end_rank">- {{ award.end_rank }}.</span> {{ $t('label.rank') }}
				</chip>
				<p class="text-sm" v-if="award.gender === 'm'">{{ $t('label.only_male') }}</p>
				<p class="text-sm" v-else-if="award.gender === 'f'">{{ $t('label.only_female') }}</p>
			</div>
		</template>
	</feature-item>
</template>

<script>
import {toEuro} from "@spoferan/spoferan-ts-core";

export default {

        name: 'Award',

        props: {

            award: {
                type: Object,
                required: true
            },

            divided: {
                type: Boolean,
                default: false
            }
        },

        methods: {
            toEuro(val) {
                return toEuro(val);
            }
        }
    }
</script>